import React from 'react'
import {
  Control,
  UseFormTrigger,
  UseFormGetValues,
  UseFormResetField,
  UseFormSetValue,
  Path,
  RegisterOptions,
} from 'react-hook-form'

import ConstructionYear from '../common/ConstructionYear'
import Floor from '../common/Floor'
import Heat from '../common/Heat'
import HeatType from '../common/HeatType'
import Parking from '../common/Parking'
import ParkingSlots from '../common/ParkingSlots'
import Door from '../common/Door'
import EnergyClass from '../common/EnergyClass'
import Garden from '../common/Garden'
import GardenSqr from '../common/GardenSqr'
import Frames from '../common/Frames'
import Windows from '../common/Windows'
import FloorType from '../common/FloorType'
import Access from '../common/Access'
import Direction from '../common/Direction'
import View from '../common/View'
import Renovation from '../common/Renovation'
import RenovationYear from '../common/RenovationYear'
// import Baths from '../common/Baths'
import Wc from '../common/Wc'
import Balcony from '../common/Balcony'
import Elevator from '../common/Elevator'
import Alarm from '../common/Alarm'
import Safe from '../common/Safe'
import Fireplace from '../common/Fireplace'
import Maintained from '../common/Maintained'
import Cctv from '../common/Cctv'
import DisabledAccess from '../common/DisabledAccess'
import Facade from '../common/Facade'
import Corner from '../common/Corner'
import AirCondition from '../common/AirCondition'
import Storage from '../common/Storage'
import StorageSqr from '../common/StorageSqr'
import Loft from '../common/Loft'
import LoftSqr from '../common/LoftSqr'
// import Penthouse from '../common/Penthouse'
import ElectricityType from '../common/commercial/ElectricityType'
import StructuredWiring from '../common/commercial/StructuredWiring'
import FalseCeiling from '../common/commercial/FalseCeiling'
import FireSafety from '../common/commercial/FireSafety'
import Spaces from '../common/commercial/Spaces'
import Kitchen from '../common/commercial/Kitchen'
import InternalStairs from '../common/commercial/InternalStairs'
import FoodService from '../common/commercial/FoodService'
import Equipment from '../common/commercial/Equipment'
// import Equipped from '../common/commercial/Equipped'
import SecurityRolls from '../common/commercial/SecurityRolls'
import CargoRamp from '../common/commercial/CargoRamp'
import CargoElevator from '../common/commercial/CargoElevator'
import CargoElevatorLoad from '../common/commercial/CargoElevatorLoad'

import { FormValues } from '..'
import BalconySqr from '../common/BalconySqr'
interface Props {
  control: Control<FormValues>
  trigger: UseFormTrigger<FormValues>
  getValues: UseFormGetValues<FormValues>
  resetField: UseFormResetField<FormValues>
  setValue: UseFormSetValue<FormValues>
  name?: Path<FormValues>
  rules?: RegisterOptions
}

const CommercialStoreFields = (props: Props) => {
  const { control, trigger, getValues, resetField, setValue } = props
  return (
    <>
      <ConstructionYear
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Renovation
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <RenovationYear
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Floor
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Spaces
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Wc
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Balcony
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <BalconySqr
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Heat
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <HeatType
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Parking
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <ParkingSlots
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <FoodService
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Garden
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <GardenSqr
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Storage
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <StorageSqr
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Loft
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <LoftSqr
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Door
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Alarm
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Safe
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <EnergyClass
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Facade
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      {/* <Furnished />  */}
      {/* <Equipped
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      /> */}
      <Equipment
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <StructuredWiring
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <FalseCeiling
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <FloorType
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <AirCondition
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Fireplace
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Frames
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Windows
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <FireSafety
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Maintained
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Cctv
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <SecurityRolls
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <ElectricityType
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Access
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <DisabledAccess
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Corner
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Direction
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <View
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <CargoRamp
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Elevator
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <CargoElevator
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <CargoElevatorLoad
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <InternalStairs
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Kitchen
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
    </>
  )
}

export default React.memo(CommercialStoreFields)
